<div class="row" [class.flex-column-reverse]="!inFlyout">
  <div class="col-24 col-md pt-1">
    <div class="links-grid">
      <shrd-uic-nav-button
        *ngFor="let link of categories?.childList"
        class="nav-btn"
        [label]="link.title"
        [headlineText]="link.headline"
        [imgUrl]="link.thumbnail"
        [imgAlt]="link.title"
        [isTextIndent]="true"
        [url]="link.url"
        [shrdUtcTrackEvent]="
          categories.menuType === productMenuType.CATEGORY
            ? {
                category: 'SiteOperations',
                action: 'MainNavigation',
                label: menuTitle + '|L2:' + link.title
              }
            : null
        "
      ></shrd-uic-nav-button>
    </div>
    <ng-container *ngIf="teasers$ | async as teasers">
      <hr shrdUicHr [lineHeight]="4" />
      <div class="links-grid">
        <shrd-uic-nav-button
          *ngFor="let teaser of teasers"
          class="nav-btn"
          [label]="teaser.body"
          [headlineText]="teaser.headline"
          [imgUrl]="teaser.imageUri"
          [imgAlt]="teaser.imageAlt || teaser.headline"
          [isTextIndent]="true"
          [url]="teaser.linkUri"
          (click)="trackTeaserClick(teaser)"
        ></shrd-uic-nav-button>
      </div>
    </ng-container>
  </div>

  <div class="banner-col col-24 col-md-6 pt-2 pt-md-1 pb-1 pb-md-0" *ngIf="banner$ | async as banner">
    <div class="h-100 position-relative bg-neutral-megalight">
      <shrd-uic-master-banner
        *ngIf="banner.loaded"
        [bannerOverline]="banner.overline"
        [bannerHeadline]="banner.headline"
        [mobileHeadline]="banner.mobileHeadline"
        [bannerSubline]="banner.subHeadline"
        [bannerBodyText]="banner.body"
        [buttonText]="banner.links?.[0]?.label"
        [buttonTarget]="banner.links?.[0]?.uri"
        [imageUrl]="banner.imageUri"
        [isLifestyle]="banner.layout === bannerLayout.LIFESTYLE"
        [bannerSize]="bannerSize"
        (click)="trackBannerClick(banner)"
      ></shrd-uic-master-banner>
      <shrd-uic-preloader [active]="!banner.loaded" immediate></shrd-uic-preloader>
    </div>
  </div>
</div>
